import { gql } from 'urql'
export const FragGuideIndexInfoPageSection = gql`
  fragment GuideIndexInfoPageSection on GuideIndexInfoPageSection {
    content {
      title
      description
    }
  }
`
